import { Box } from "@mui/material"
import { TemplateModal } from "./TemplateModal"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProductData } from "../../types";

interface AddTemplateProps {
  products: ProductData[];
  refetchTemplates: () => void;
}

export const AddTemplate = ({ refetchTemplates, products }: AddTemplateProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/templates');
  }

  const handleSave = () => {
    navigate('/templates');
    refetchTemplates();
  }
  
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="add-product">
      <TemplateModal 
        open={open} 
        handleClose={handleClose} 
        handleSave={handleSave} 
        products={products} 
        template={{  }} 
      />
    </Box>
  )
}